import { getActiveUser } from "@noom/hive-auth";
import { MeristemExperimentInfo, TrackingParams } from "gql/graphql";
import { appConfig } from "src/config";
import { getAccessToken } from "src/utils/authCookieParser";
import { getVisitedExperiments } from "src/utils/experiment";
import { getURLParams } from "src/utils/urlParams";
import visitTracker from "@noom/visit-tracker";

export function getAuthorizationHeader() {
  const userAccessToken = getActiveUser()?.accessToken ?? getAccessToken();
  const token = userAccessToken ?? appConfig.LOGGED_OUT_BUYFLOW_CLIENT_TOKEN;
  return { Authorization: `Bearer ${token}` };
}

export function getAnonymousClientAuthorizationHeader() {
  return {
    Authorization: `Bearer ${appConfig.LOGGED_OUT_BUYFLOW_CLIENT_TOKEN}`,
  };
}

export function getTrackingParams(): TrackingParams {
  const urlParams = getURLParams();
  const visitTrackerParams = visitTracker.getTrackingParams();

  return {
    initialUrl: visitTrackerParams?.initialUrl,
    referrer: visitTrackerParams?.referrer,
    utmSource: urlParams.utm_source,
    utmMedium: urlParams.utm_medium,
    utmCampaign: urlParams.utm_campaign,
    utmContent: urlParams.utm_content,
    utmTerm: urlParams.utm_term,
    feature: urlParams.feature ? [urlParams.feature].flat() : [],
  };
}

export function getExperimentsInfo(): MeristemExperimentInfo[] {
  return getVisitedExperiments().map(([context, experiment]) => ({
    context,
    experimentName: experiment.experimentName,
    variationName: experiment.variationName,
  }));
}
